<template>
    <div class="modal" @click="$emit('close')">
        <div class="modal-block" @click.stop>
                <h2>Напишите, почему вы хотите пожаловаться на этот контент</h2>
                <TextareaAutosize
                    class="textarea"  
                    rows="1"
                    v-model="content"
                    placeholder="Опишите проблему"
                    maxlength="2000"
                />
                <div class="button" @click="sendComplain()">
                    <p>Отправить</p>
                </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Complain',
    data: () => {
        return {
            content: '',
        }
    },
    props: {
        settings: {
            type: Object,
            require: true
        }
    },
    methods: {
        async sendComplain() {
            if (this.content.length > 10) {
                await this.$axios
                .post(`/api/feedbacks/complain`, {
                    content: this.content,
                    pin_id: this.settings.type === 'pin' ? this.settings.pin.id : null,
                    comment_id: this.settings.type === 'comment' ? this.settings.comment.id : null,
                    person_id: this.settings.type === 'user' ? this.settings.user.id : null,
                    event_id: this.settings.type === 'event' ? this.settings.event_id : null,
                    place_id: this.settings.type === 'place' ? this.settings.place_id : null,
                })
                .then(() => {
                    this.$store.dispatch('addNotification', {message: 'Ваша жалоба отправлена!'})
                    this.content = ''
                    this.$emit('close')
                })
            } else {
                this.$store.dispatch('addError', {message: 'Заполните поле жалобы'})
            }
        }
    }
}
</script>
<style lang="stylus" scoped>
.modal
    &-block
        max-width 500px
        h2
            font-size 18px
            font-weight 500
        
        .textarea
            background-color #f0f0f0
            width 100%
            margin-top 20px
            border-radius 15px
            border none
            font-size 14px
            line-height 18px
            padding 20px
        
        .button
            margin-top 20px
            p
                color black
            &:hover
                p
                    color white
</style>